import type { ListFavoriteFacilitiesParams } from '@gyym/sdk'
import { useGyymClient, useGyymSWR } from '@gyym/sdk-react'
import type { SWRConfiguration } from 'swr'

import { useAuthUser } from '@/modules/Auth'

export const useFavoritedFacilities = (
  params?: ListFavoriteFacilitiesParams,
  enabled = true,
  options: SWRConfiguration = {},
) => {
  const client = useGyymClient()
  const { isLoggedIn, isEmailVerified } = useAuthUser()

  return useGyymSWR(
    // Don't fetch if the user isn't logged in
    isLoggedIn && isEmailVerified && enabled
      ? [client.user.favorites.listFacilities, params]
      : null,
    options,
  )
}
